<template>
    <div>

        <b-breadcrumb>
            <b-breadcrumb-item to="/">
                <i class="fa fa-home"></i>
                Home
            </b-breadcrumb-item>
            <b-breadcrumb-item to="/AzureBillingPeriods">Azure Billing Periods</b-breadcrumb-item>
            <b-breadcrumb-item>{{billingPeriodId}}</b-breadcrumb-item>
            <b-breadcrumb-item active>Subscriptions</b-breadcrumb-item>
        </b-breadcrumb>

        <div class="card">
            <div class="bg-dark card-header text-white">Subscription Listing</div>
            <div class="card-body">

                <BTable
                        :busy="isLoading"
                        :fields="tableFields"
                        :items="subscriptions"
                        :responsive="true"
                        primary-key="id"
                        show-empty
                        striped
                        :per-page="filterOptions.pageSize"
                        :current-page="filterOptions.page"
                        table-class="table-align-middle">

                    <template v-slot:cell(id)="row">
                        <router-link
                                :to="{name:'AzureBillingSubscriptionDetails',params:{subscriptionId:row.item.id,billingPeriodId:billingPeriodId}}"
                                class="btn btn-sm btn-warning d-print-none"
                                data-toggle="tooltip"
                                title="Edit general code details">
                            <i class="fa fa-pencil-alt"></i>Edit
                        </router-link>
                    </template>

                    <template v-slot:cell(costCenter)="row">
                        <span>{{row.item.sl + '-'+row.item.sa}}</span>
                    </template>

                    <!-- Footer Pagination -->
                    <template v-slot:custom-foot>
                        <b-tr>
                            <b-td :colspan="tableFields.length">
                                <AppTablePagination
                                        :page.sync="filterOptions.page"
                                        :pageSize.sync="filterOptions.pageSize"
                                        :totalCount.sync="totalSubscriptions"
                                ></AppTablePagination>
                            </b-td>
                        </b-tr>
                    </template>

                </BTable>

            </div>
        </div>

    </div>
</template>

<script>
    import AzureBillingService from "@/services/AzureBillingService";
    import AppTablePagination from "@/components/shared/AppTablePagination";
    import {currency} from "@/filters/Currency";
    import {date} from "@/filters/Date"

    export default {
        components: {
            AppTablePagination,
        },
        filters: {
            currency,
            date
        },
        data() {
            return {
                billingPeriodId: null,
                subscriptions: [],
                totalSubscriptions: 0,
                isLoading: false,
                filterOptions: {
                    page: 1,
                    pageSize: 10
                },
                tableFields: [
                    {
                        key: 'id',
                        label: '',
                        thStyle: 'width:100px'
                    },
                    {
                        key: 'name',
                        label: 'Name',
                    },
                    {
                        key: 'organizationCode',
                        label: 'Organization Code',
                    }, {
                        key: 'principalInvestigatorName',
                        label: 'Principal Investigator',
                    },
                    {
                        key: 'costCenter',
                        label: 'Cost Center',
                        thStyle: 'width:150px'
                    },
                ]
            }
        },
        methods: {
            /**
             * @description Loads the data from the API with the filter options bound to the component
             */
            loadData() {
                const vm = this;
                vm.isLoading = true;

                AzureBillingService.getBillingPeriodSubscriptions(vm.billingPeriodId)
                    .then(response => {
                        vm.subscriptions = response;
                        vm.totalSubscriptions = response.length;
                    })
                    .catch(() => {
                        vm.redirectToError()
                    }).finally(() => {
                    vm.isLoading = false;
                })
            },
        },
        created() {
            this.billingPeriodId = this.$route.params.billingPeriodId;
            this.loadData();
        }
    }
</script>
